import { defaultDirection } from "../config/defaultValues";
import _moment from "../libs/moment";
const querystring = require('querystring')

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key], B = b[key];
    if (order.indexOf(A + "") > order.indexOf(B + "")) {
      return 1;
    } else {
      return -1;
    }
  });
  return array;
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem("direction")) {
    const localValue = localStorage.getItem("direction");
    if (localValue === "rtl" || localValue === "ltr") {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === "rtl"
  };
};

export const setDirection = localValue => {
  let direction = "ltr";
  if (localValue === "rtl" || localValue === "ltr") {
    direction = localValue;
  }
  localStorage.setItem("direction", direction);
};

// devuelve un objeto con solo los atrbibutos que tienen un valor valido
export const objToQueryString = (obj, questionMark, ampersand) => {
  if (!obj) return ''
  let o = JSON.parse(JSON.stringify(obj))
  for(var key in o) {
    if(o[key] === null || o[key] === undefined || o[key] === "" || o[key] === " ") delete o[key]
    if (typeof o[key]  === "object") o[key] = o[key].value
  }
  if (Object.keys(o).length === 0 && o.constructor === Object) return ''
  else return (questionMark ? '?' : '') + (ampersand ? '&' : '') + querystring.stringify(o)
}

export const openLink = (url) => {
  window.open(url, '_blank')
}

export const resizeImage = (str, maxWidth = 800) => {
  return new Promise((resolve) => {
    let img = new Image()
    img.src = str
    img.onload = () => {
      let canvas = document.createElement('canvas')
      let w = maxWidth
      let r = w / img.width
      let h = img.height * r
      canvas.width = w
      canvas.height = h
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      resolve(canvas.toDataURL('image/jpeg'))
    }
  })
}

export const rgbToHex = (rgb) => {
  var match = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  
  if (!match) {
    return rgb;
  }
  
  var r = parseInt(match[1]).toString(16);
  var g = parseInt(match[2]).toString(16);
  var b = parseInt(match[3]).toString(16);
  
  if (r.length === 1) r = "0" + r;
  if (g.length === 1) g = "0" + g;
  if (b.length === 1) b = "0" + b;
  
  return "#" + r + g + b;
}

export const getFileExtension = (filename) => {
  if (typeof filename !== "string") return
  const extension = filename.split('.').pop();
  return extension.toLowerCase();
}

export const decimalFormat = (num) => {
  const parsedNum = Number(num)
  return !isNaN(parsedNum) ? parsedNum.toFixed(2) : ''
}

export const addPrefixToObjectKeys = (obj, prefix) => {
  const result = {};
  for (const key in obj) {
    result[`${prefix}${key}`] = obj[key];
  }
  return result;
}

export const  getValueOfParameterFromURL = (param, href) => {
  const url = window.location.href?? href;
  const length = `${param}=`.length
  const indiceInicio = url.indexOf(`${param}=`);

  if (indiceInicio !== -1) {
    var indiceFin = url.indexOf("&", indiceInicio);
    var value;
    
    if (indiceFin !== -1) {
      value = url.substring(indiceInicio + length, indiceFin);
    } else {
      value = url.substring(indiceInicio + length);
    }

    value = decodeURIComponent(value);
    return value;
  } else return null;
}

export const isAndroidOrIos = () => {
  return /Android/i.test(navigator.userAgent) === true || /iPhone|iPad/i.test(navigator.userAgent) === true;
}

export const goToWhatsApp = (phone, text = "", countryCode = "") => {
  // si es dispositivo android o ios no emulado abrira el app
  if ((navigator.userAgent.match(/(android|ip(hone|ad|od))/i) && (!navigator.platform || !navigator.platform.match(/(win|mac)/i))) || navigator.userAgent.match(/(windows phone|iemobile|wpdesktop|blackberry)/i)) window.open(`whatsapp://send?${phone ? (`phone=${countryCode}${phone}&`) : ''}text=${encodeURIComponent(text)}`, '_system')
  else window.open(`https://web.whatsapp.com/send?${phone ? (`phone=${countryCode}${phone}&`) : ''}text=${encodeURIComponent(text)}`, '_blank')
}

export const findModuleInMenu = (menu, searchBy, value) => {
  let modOption = menu.find(m => m[searchBy] === value)
  // look in submenus
  if (modOption === undefined) {
    menu.forEach(m => {
      if (modOption === undefined && m.subs?.length > 0) {
        modOption = m.subs.find((sm) => sm[searchBy] === value)
      }
    })
  }
  return modOption
}

export const generateGUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
}

export const replaceWords = (str, replacements) => {
  for (let word in replacements) {
      str = str.replace(word, replacements[word])
  }
  return str
}

export const whatsToHtml = (msg) => {
  if (!msg) return;

   return msg
    .replace(/~(~*[^~\n]+~*)~/g, '<del>$1</del>')
    .replace(/_(_*[^_\n]+_*)_/g, '<em>$1</em>')
    .replace(/\*(\**[^*\n]+\**)\*/g, '<strong>$1</strong>')
    .replace(/```([^`]+)```/g, '<span style="font-family: monospace;">$1</span>')
    .replace(/(?:\r\n|\r|\n)/g, '<br>');
}

export const getNextDayOfWeek = (dayOfWeek) => {
  if (dayOfWeek < 0 || dayOfWeek > 6) {
    throw new Error('dayOfWeek must be between 0 (Sunday) and 6 (Saturday)')
  }

  const today = _moment()
  const currentDay = today.day()
  let daysUntilNext = (dayOfWeek - currentDay + 7) % 7
  
  if (daysUntilNext === 0) {
    daysUntilNext = 7
  }

  const nextDay = today.add(daysUntilNext, 'days')
  nextDay.startOf('day')

  return nextDay.format('YYYY-MM-DD')
}

export const getUsersModulePath = () => {
  const appName = window.tenant?.appName;
  return (appName === 'AppOnCloud' || appName === 'Schoolcool') ? 'admStudent' : 'admUser';
}